import { graphql, readInlineData } from 'react-relay';

type RefundTermsOutput = {
  termsKey: string;
  url: string;
};

export function getTermURL(termsRef: any, termKey: string) {
  const termOutput = readInlineData(
    graphql`
      fragment getTermURL on Query @inline @argumentDefinitions(corpType: { type: "CorpTypeEnum!" }, termsType: { type: "RefundTermsType!" }) {
        refundTerms(corpType: $corpType, termsType: $termsType) {
          termsKey
          url
        }
      }
    `,
    termsRef
  );

  const termURL = termOutput?.refundTerms?.find((item: RefundTermsOutput) => item.termsKey === termKey)?.url;

  return termURL;
}
